// Templates every map needs regardless of theme.
//
// The level generator always lays down `flat_ground` for the first two scenes
// (see LevelGenerator.reset) and falls back to it as the very first template,
// so it must exist in every map's template set. `defineProceduralMap` merges
// these into each map's level1 tier — map authors never have to remember it.
export const coreTemplates = {
  flat_ground: {
    layout: `
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
BBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
`,
    metadata: {},
  },
};
